import { Lightning, Launch, PlatformSettings, AppData } from '@lightningjs/sdk'
import { App } from './App'
import { AppSetup } from './lib/app-setup'
import { AppParams } from './lib/app-params';
import { Helper } from './lib/helper';

export default function (
  appSettings: Lightning.Application.Options,
  platformSettings: PlatformSettings,
  appData: AppData,
) {
  const appSetup = new AppSetup()
  const params: AppParams = new AppParams()
  const url = new URL(window.location.href)
  const qs: any = {}
  url.searchParams.forEach((v, k) => (qs[k] = v))
  Object.assign(params, qs)
  appSetup.setAppConfig(params)
  appSetup.createPlatform()
  appSetup.initCCOptions()
  appSetup.platform?.setKeyMappings(appSettings)
  document.body.style.backgroundColor = '#000000'
  document.body.style.overflow = 'hidden'
  document.documentElement.style.overscrollBehavior = 'none'
  document.body.style.overscrollBehavior = 'none'  //overscroll-behavior= none;
  appSetup.appConfig?.setupPath(platformSettings)
  if(appSetup.appConfig?.consoleDebugLog) {
    appSettings.debug = true
    platformSettings.log = true
  } else {
    appSettings.debug = false
    platformSettings.log = false
  }
  Helper.getScripts(appSetup.platform?.getScript(platformSettings), 'defer')
  appSetup.platform?.getAppOptions(appSettings, platformSettings)
  // console.log(appSettings, platformSettings)
  return Launch(App, appSettings, platformSettings, appSetup)
}
